import { render, staticRenderFns } from "./CommonPagination.vue?vue&type=template&id=07dc85f8&"
import script from "./CommonPagination.js?vue&type=script&lang=js&"
export * from "./CommonPagination.js?vue&type=script&lang=js&"
import style0 from "./CommonPagination.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports